import PropTypes from "prop-types"
import React, { useEffect } from "react"

import { Route, Routes } from "react-router-dom"
import { connect, useSelector } from "react-redux"

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
// import "./assets/scss/colorTheme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import Fack Backend
import fakeBackend from "./helpers/AuthType/fakeBackend"
import { createSelector } from "reselect"
import { Helmet } from "react-helmet"

// Activating fake backend
fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const selectLoginState = state => state.Login
const LoginProperties = createSelector(selectLoginState, login => ({
  loggedUser: login.loggedUser,
}))

const App = props => {
  const { loggedUser } = useSelector(LoginProperties)
   const imgUrl = process.env.REACT_APP_IMG_APIKEY

  // Dynamic meta description and image
  const metaDescription =
    loggedUser?.settings?.companyinfo ||
    "EverRise by iTrobes"
  const metaImage =
    loggedUser?.settings?.companyfavicon
      ? `${imgUrl}${loggedUser.settings.companyfavicon}`
      : "/meta-logo-500.png"
  const favicon =
    loggedUser?.settings?.mob_svg
      ? `${imgUrl}${loggedUser.settings.mob_svg}`
      : "/favicon1.png"
      const titleTag = loggedUser?.settings?.companyname || "MEP by iTrobes"

    const themeCheck = localStorage?.getItem("themeManage")

  useEffect(() => {
    // Conditionally import color theme based on loggedUser's theme setting
    console.log(`themeManage`, themeCheck);
    
    if (themeCheck == 1 || loggedUser?.settings?.theme_option == 1) {
      import("./assets/scss/colorTheme.scss")
    } else if (themeCheck == 2 || loggedUser?.settings?.theme_option == 2) {
      document.documentElement.style.setProperty(`--border`, "#AAC3F6")
      document.documentElement.style.setProperty(`--tbl-head`, "#4B80EE")
      document.documentElement.style.setProperty(`--tbl-body`, "#7E879A")
      document.documentElement.style.setProperty(`--primary`, "transparent")
      document.documentElement.style.setProperty(`--border`, "#E7EFFF")
      document.documentElement.style.setProperty(`--btnDark`, "#4B80EE")
      document.documentElement.style.setProperty(`--menuDark`, "#E4EDFF")
      document.documentElement.style.setProperty(`--border-no`, "1px solid #D8E1F2")
      document.documentElement.style.setProperty(`--menu-avtive`, "#E4EDFF")
      document.documentElement.style.setProperty(`--menu-avtive-txt`, "#4B80EE")
      document.documentElement.style.setProperty(`--accent-clr`, "#4B80EE")
      document.documentElement.style.setProperty(`--input-focus`, "#CEDEFF")
      document.documentElement.style.setProperty(`--backarrow-color`, "#4B80EE")
      document.documentElement.style.setProperty(`--export-btn`, "#E7EFFF")
      document.documentElement.style.setProperty(`--inner-tbl`, "#E4EDFF")
      document.documentElement.style.setProperty(`--input-disable`, "#F4F4F4")
      document.documentElement.style.setProperty(`--text-extra-high`, "#4B80EE")
      document.documentElement.style.setProperty(`--placeholder`, "#c3c4c7")
      document.documentElement.style.setProperty(`--file-upload-bg`, "#F5F9FE")
      document.documentElement.style.setProperty(`--file-upload-br`, "#C0D0F1")
      document.documentElement.style.setProperty(`--file-txt`, "#4B80EE")
      document.documentElement.style.setProperty(`--select-hover`, "#D4E2FF")
      document.documentElement.style.setProperty(`--chart-label`, "#4B80EE")
      document.documentElement.style.setProperty(`--chart-light`, "#D9E5FF")
      document.documentElement.style.setProperty(`--multi-input`, "#E4EDFF")
      document.documentElement.style.setProperty(`--calender-primary`, "#E4EDFF")
      document.documentElement.style.setProperty(`--icon-clr`, "#4B80EE")
      document.documentElement.style.setProperty(`--calender-dark`, "#E4EDFF")
      document.documentElement.style.setProperty(`--inrange-clr`, "#E4EDFF")
      document.documentElement.style.setProperty(`--sec-btn`, "#FFB703")
      document.documentElement.style.setProperty(`--accord-clr`, "#4B80EE")
      document.documentElement.style.setProperty(`--calender-main`, "#4B80EE")
      document.documentElement.style.setProperty(`--calender-selected`, "#4B80EE")
      document.documentElement.style.setProperty(`--note-background`, "#E4EDFF")
    }
  }, [loggedUser?.settings?.theme_option])
  function getLayout() {
    let layoutCls = VerticalLayout

    switch (props.layout.layoutType) {
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()
  return (
    <React.Fragment>
      <Helmet>
        <meta name="description" content={metaDescription} />
        <meta property="og:image" content={metaImage} />
        <link rel="icon" href={favicon} />
        <title>{titleTag}</title>
      </Helmet>
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            isAuthProtected={false}
          />
        ))}

        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                {route.path == "/network-error" ? (
                  <div>{route.component}</div>
                ) : (
                  <Layout>{route.component}</Layout>
                )}
              </Authmiddleware>
            }
            key={idx}
            isAuthProtected={true}
            exact
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
